import { z } from 'zod';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const customerFormSchema = z.object({
  firstName: z
    .string()
    .trim()
    .nonempty('Förnamn är obligatoriskt')
    .max(50, { message: 'Förnamnet får inte överstiga 50 tecken' }),
  lastName: z
    .string()
    .trim()
    .nonempty('Efternamn är obligatoriskt')
    .max(50, { message: 'Efternamnet får inte överstiga 50 tecken' }),
  email: z.string().trim().email('Ogiltig e-postadress'),
  mobileNumber: z
    .string()
    .trim()
    .refine(
      (value) => {
        const phoneNumber = parsePhoneNumberFromString(value, 'SE');
        return phoneNumber?.isValid();
      },
      { message: 'Ogiltigt mobilnummer' },
    ),
  street: z
    .string()
    .trim()
    .nonempty('Gatuadress är obligatorisk')
    .max(100, { message: 'Gatuadressen får inte överstiga 100 tecken' }),
  city: z
    .string()
    .trim()
    .nonempty('Postort är obligatorisk')
    .max(50, { message: 'Stadsnamnet får inte överstiga 50 tecken' }),
  postalCode: z
    .string()
    .trim()
    .regex(/^\d{5}$/, { message: 'Postnumret måste bestå av 5 siffror' }),
  country: z
    .string()
    .trim()
    .nonempty('Land är obligatoriskt')
    .max(50, { message: 'Landsnamnet får inte överstiga 50 tecken' }),
});
